import React from "react";
import Category from "Pages/Profile/Category";

export default function DashCategoryPageTheme() {
  return (
    <>
      <Category />
    </>
  );
}
